import { render, staticRenderFns } from "./ListaCliente.vue?vue&type=template&id=1eab112a&scoped=true&"
import script from "./ListaCliente.vue?vue&type=script&lang=js&"
export * from "./ListaCliente.vue?vue&type=script&lang=js&"
import style0 from "./ListaCliente.vue?vue&type=style&index=0&id=1eab112a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eab112a",
  null
  
)

export default component.exports